<main class="auth-page">


   <div class="loading-row">
      <div class="spinner" aria-hidden="true"></div>
      </div>
  <!-- <section class="auth-hero">

     <div class="loading-row">
      <div class="spinner" aria-hidden="true"></div>
      </div> 
     <div class="brand-mark" aria-hidden="true">CC</div>

    <div class="auth-copy">
      <p class="eyebrow">Cidaas Authentication</p>
      <h1>CiamCom Admin Console</h1>
      <p class="muted">
        Sign in with the same ACP Cidaas flow used by the auth reference app. After authentication you will be redirected
        back to this admin application.
      </p>
    </div>

    <div class="loading-row">
      <div class="spinner" aria-hidden="true"></div>
      <span *ngIf="!(isAuthenticated$ | async)">Redirecting to ACP Cidaas...</span>
      <span *ngIf="isAuthenticated$ | async">Authentication complete. Redirecting to dashboard...</span>
    </div>

    <div class="actions">
      <p-button label="Sign In" icon="pi pi-sign-in" styleClass="auth-action" (onClick)="login()" />
    </div>

    <p class="auth-footer">CiamCom Admin &copy; {{ currentYear }}</p> 
  </section> -->
</main>
